import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=63a7843c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=63a7843c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a7843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a7843c')) {
      api.createRecord('63a7843c', component.options)
    } else {
      api.reload('63a7843c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=63a7843c&scoped=true&", function () {
      api.rerender('63a7843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21g3Gvq3imkY8/JS/comp/CookieBox.vue"
export default component.exports